
import Cookies from "plugins/cookies-js/index"

// See server-side code
// app/controllers/concerns/shared/with_listing_search_attributes.rb
const Cookie_key = "disable_should_save_search_notice"

const ShouldSaveSearchNotice = {
  disable_notice(){
    if (! Cookies.enabled) { return }

    Cookies.set(Cookie_key, "true", {
      // expire in 1 week
      expires: 2 * 24 * 60 * 60,
    })
  },
  enable_notice(){
    if (! Cookies.enabled) { return }

    if (this.notice_is_disabled()){
      Cookies.expire(Cookie_key)
    }
  },
  notice_is_disabled(){
    return Cookies.get(Cookie_key)
  },
}

export default ShouldSaveSearchNotice
